import React from 'react';
import styled from 'styled-components';

import Typography from '@material-ui/core/Typography';
import {TypographyProps, withStyles} from '@material-ui/core';

import {ValueFormatter} from '@epic-visualizations/charts';

import {getDirectionStyles} from '../../utils/ThemeUtils';

interface StyledTypographyProps extends TypographyProps {
    component: string;
}

const StyledTypography = withStyles<string, undefined, StyledTypographyProps>(theme => ({
    root: {
        float: getDirectionStyles(theme.direction)('none', 'right')
    }
}))(Typography);

const Line = styled.span<{
    isSelected: boolean;
}>`
    display: inline-block;
    font-weight: bold;
    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 1, 0, 0),
            p.theme.muiTheme.spacing(0, 0, 0, 1)
        )};
    color: ${p =>
        p.isSelected
            ? p.theme.muiTheme.palette.warning.main
            : p.theme.muiTheme.palette.dividerStrong};
`;

export interface StatisticsTrendProps {
    value: number | string | ValueFormatter<undefined>;
    isSelected?: boolean;
}

const StatisticsTrend = ({value, isSelected}: StatisticsTrendProps) => (
    <StyledTypography variant="body2" component="span">
        {value && value !== '0' ? (
            value
        ) : (
            <>
                <Line isSelected={isSelected}>-</Line>0
            </>
        )}
    </StyledTypography>
);

export default StatisticsTrend;
